export enum DataCollectionSource {
  Recollection = 'recollection',
  Onboarding = 'onboarding',
}

export enum PaymentProvider {
  UsBank = 'us_bank',
}
